export const findNotDisabledElement = ({
  target,
  reverse,
  startWithTarget,
}: {
  target: HTMLElement;
  reverse?: boolean;
  startWithTarget?: boolean;
}): HTMLElement | null => {
  const sibling = reverse ? (target as HTMLElement).previousElementSibling : (target as HTMLElement).nextElementSibling;

  const element = startWithTarget ? target : sibling;

  if (!element) {
    return null;
  }

  if (typeof element.getAttribute('disabled') === 'string') {
    return findNotDisabledElement({ target: element as HTMLElement, reverse });
  }

  return element as HTMLElement;
};
